import { StyleSheet, Text, View } from "react-native";
import React from "react";

const CreateProject = () => {
  return (
    <View>
      <Text>CreateProject</Text>
    </View>
  );
};

export default CreateProject;

const styles = StyleSheet.create({});
